module.exports = __webpack_public_path__ + "img/case43-jpg.1718d9c3.jpg";